import './App.css';
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Onboarding from './pages/onboarding/onboarding'
import ErrorSnackbar from './components/ErrorSnackbar/ErrorSnackbar';
import { useSelector } from "react-redux";
import AgentAssist from './pages/agentassist/AgentAssist.jsx';
import Dataimport from './pages/dataimport/dataimport';
import PageNotFound from './pages/pagenotfound/pagenotfound';
import Login from './pages/login/Login.jsx';
import { AuthProvider } from './utils/auth';
import ROUTES from './constants/routes';
import RequireAuth from './components/RequireAuth';
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth'
import { useDispatch } from 'react-redux';
import { getOrgData } from './api';
import { saveEmail } from './redux/actions/authActions';
import VerifyPage from './pages/Verify/Verify.jsx';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword.jsx';

function App() {
  const snackbarState = useSelector((state) => state.error);
  const isAuthenticatedUser = useSelector((state) => state.auth.isAuthenticatedUser)
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const orgDetails = useSelector((state) => state.auth.orgDetails);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subDomain = queryParams.get('subDomain');

  useEffect(() => {
    const authenticate = async () => {
      try {
        await fetchAuthSession();
        const userAttributes = await fetchUserAttributes();
        if (userAttributes?.email) {
          dispatch(saveEmail(userAttributes?.email))
        }
      } catch (err) {
        console.error("err", err)
      }
      setIsAuthenticating(false)
    }
    if (!Object.keys(orgDetails).length && subDomain) {
      dispatch(getOrgData(subDomain))
    }
    if (Object.keys(orgDetails).length) {
      authenticate()
    }
  }, [orgDetails, subDomain, dispatch])

  return (
    <>
      <AuthProvider >
        <Routes>
          <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
          <Route exact path={ROUTES.DATAIMPORT} element={<Dataimport />} />
          <Route exact path={ROUTES.INDEX} element={<VerifyPage />} />
          <Route exact path={ROUTES.VERIFY} element={<VerifyPage />} />

          {!isAuthenticating && (
            <>
              <Route exact path={ROUTES.AGENT.LOGIN} element={!isAuthenticatedUser ? <Login /> : <PageNotFound />} />
              <Route exact path={ROUTES.AGENT.FORGOT_PASSWORD} element={!isAuthenticatedUser ? <ForgotPassword /> : <PageNotFound />} />
              <Route exact path="/" element={<VerifyPage />} />
              <Route path={ROUTES.GPT} element={<RequireAuth><AgentAssist aaTabIndex={0} /></RequireAuth>} />
              <Route path={ROUTES.RESEARCH} element={<RequireAuth><AgentAssist aaTabIndex={1} /></RequireAuth>} />
              <Route path={ROUTES.SUMMARY} element={<RequireAuth><AgentAssist aaTabIndex={2} /></RequireAuth>} />
              <Route path={ROUTES.NOT_FOUND} element={<PageNotFound />} />
            </>
          )}
        </Routes>
        <ErrorSnackbar isOpen={snackbarState.status} message={snackbarState.message} severity={snackbarState.severity} />
      </AuthProvider>
    </>
  );
}

export default App;